export default {
    信息验证: 'Xác thực thông tin liên lạc',
    运营商: 'Nhà mạng',
    请稍等:'Vui lòng đợi...',
    取消授权:'Huỷ ủy quyền',
    身份验证:'Xác thực danh tính',
    请您选择您的电话服务提供商:'Vui lòng chọn nhà cung cấp dịch vụ điện thoại của bạn',
    电话号码格式不正确:'Số điện thoại không đúng định dạng',
    请输入OTP:'Vui lý nhap OTP',
    OTP只能是数字:'OTP chỉ có thể là số',
    电话服务提供商:'Nhà cung cấp dịch vụ điện thoại',
    请输入电话号码:'Nhập số điện thoại',
    接收OTP:'Lấy mã xác thực',
    获取OTP:'Lấy mã xác thực',
    重新获取OTP: 'Lấy lại OTP ',
    选择运营商: 'Chọn nhà cung cấp dịch vụ điện thoại',
    授权成功: 'Xác thực thành công Sau ba giây sẽ tự động chuyển hướng.',
    手动跳转: 'Chuyển hướng thủ công',
    验证失败: " xác thực không thành công", 
    返回首页: "Trở về trang chủ",
    正在获取otp: "Đang lấy mã xác thực",
    请输入收到的OTP验证码: "Vui lòng nhập mã xác thực OTP đã nhận được",
    验证码已发送: "Mã xác thực đã được gửi đến số điện thoại của bạn",
    网络错误:"Lỗi mạng, vui lòng liên hệ với quản trị viên.",
    请重新获取一次验证码:"Xác thực đã hết hạn, vui lòng nhấp lại để nhận mã xác thực và thử lại.",
    验证码有效期:"Thời gian hiệu lực của mã xác nhận"
};
